import get from 'lodash/get';
import { behaviors as GuideItemBehaviors } from '../guideItemTypes';

export default function isLocked(guideItem) {
  return (
    get(guideItem, 'behaviors.default.actionName') ===
    GuideItemBehaviors.subscribe
  );
}
